import { render } from "./IconScan2D.vue?vue&type=template&id=1dae749c"
import script from "./IconScan2D.vue?vue&type=script&lang=ts"
export * from "./IconScan2D.vue?vue&type=script&lang=ts"
script.render = render

export default script